import React from 'react'
import {
    StyledAuthorImage,
    StyledNoImageGradient,
    StyledShadow,
    StyledSquareIcon,
} from './ReportersLiveStyled'
import { IconUserTN } from '../../../icons/IconUserTN/IconUserTN'

type Props = {
    src?: string
    size: 'small' | 'large'
    isShadowView?: boolean
}

export const AuthorImage = ({ src, size, isShadowView = false }: Props) => {
    const sizePx = size === 'small' ? 24 : 40

    if (!src) {
        return (
            <StyledShadow size={sizePx}>
                <StyledNoImageGradient size={sizePx}>
                    <StyledSquareIcon size={size === 'small' ? 14.4 : 24}>
                        <IconUserTN fill={'#000000'} />
                    </StyledSquareIcon>
                </StyledNoImageGradient>
            </StyledShadow>
        )
    }
 
    return (
        <StyledAuthorImage
            isShadowView={isShadowView}
            size={sizePx}
            src={src}
            alt={'Journalist Image'}
        />
    )
}
